import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ConsultaConsumidorPageRoutingModule } from './consulta-consumidor-routing.module';

import { ConsultaConsumidorPage } from './consulta-consumidor.page';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { ButtonModule, InputNumberModule, FileUploadModule, DialogModule, RadioButtonModule, ConfirmDialogModule, DropdownModule, ToolbarModule, TableModule } from 'primeng';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    InputNumberModule,
    FileUploadModule,
    DialogModule,
    RadioButtonModule,
    ConfirmDialogModule,
    CurrencyMaskModule,
    DropdownModule,
    ToolbarModule,
    TableModule,
    FormsModule,
    IonicModule,
    ConsultaConsumidorPageRoutingModule
  ],
  declarations: [ConsultaConsumidorPage]
})
export class ConsultaConsumidorPageModule {}
